import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

/**
 * Gates a route behind a signed-in session.
 *
 * This is a convenience, not a security boundary. The bundle is public and
 * anyone can read the code behind it — what actually protects the data is the
 * API refusing unauthenticated requests. This only decides what to render.
 *
 * While the session check is in flight we render nothing rather than
 * redirecting, otherwise every page load would flash the login screen before
 * settling.
 */
export default function RequireAuth({ children }) {
  const { isSignedIn, isChecking } = useAuth();
  const location = useLocation();

  if (isChecking) return null;

  if (!isSignedIn) {
    // Remember where they were headed so sign-in can return them there.
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
}
